import styled from 'styled-components';

import { breakpoints } from '../../constants';

interface IProps {
    hideCard: boolean;
}

export const CardOuter = styled.div<IProps>`
    position: relative;
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    cursor: pointer;
    opacity: ${(props) => (props.hideCard ? 0 : 1)};
    z-index: 2;

    @media (${breakpoints.mediumMin}) {
        max-height: 400px;
        flex: initial;
    }

    @media (${breakpoints.largeMin}) {
        height: 400px;
    }
`;
